/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CodeQualityPenaltiesParser = 
/* #__PURE__ */ parsers.object([
    ['fatal', codecNumber],
    ['error', codecNumber],
    ['warning', codecNumber],
    ['info', codecNumber],
]);
export class CodeQualityPenalties extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CodeQualityPenaltiesParser.decode(input).map(res => new CodeQualityPenalties(res));
    }
    static unsafeDecode(input) {
        return CodeQualityPenalties.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CodeQualityPenaltiesParser.encode(data);
    }
    static schema() {
        return CodeQualityPenaltiesParser.schema();
    }
}
